'use client'
import type { FieldValues, UseFormRegister } from 'react-hook-form'
import { useFormContext } from 'react-hook-form'
import React, { useEffect } from 'react'
// Supabase identity (2026-08-26): the Clerk shim this used reported everyone
// signed out, so members were asked to type their email into forms again.
import { useSupabaseAuth } from '@/context/supabaseContext'
import { Email } from '../Email'

export const LoggedInUserMail: React.FC<{
  register: UseFormRegister<FieldValues>
}> = ({ register }) => {
  const { setValue, formState: { errors } } = useFormContext()
  const { user } = useSupabaseAuth()

  useEffect(() => {
    if (user?.email) {
      setValue('UserMail', user.email)
    }
  }, [user?.email, setValue])

  // If user is logged in, don't render the field (value is set programmatically)
  if (user?.email) {
    return null
  }

  // If user is not logged in, show the email input field
  return (
    <Email
      name="UserMail"
      blockType="email"
      label="Email"
      errors={errors}
      required={true}
      register={register}
    />
  )
}
